<template lang="pug">
.v-entry(@click="activate(obj)" :data-eid="obj.eid" :class="compoClasses")
  template(v-if="obj.ready")
    .pnl
      .pnl-thumb
        fit-image(:src="imgSrc" w="100" h="80" size="cover" :onloaderror="handleLoadImageError")
      .pnl-body
        .link
          a(:href="obj.url" target="_blank") {{ linkTitle }}
        .meta
          span.site(v-if="obj.site_name") {{ obj.site_name }}
          span(v-if="DEBUG") {{ obj.eid }}
        .excerpt {{ obj.excerpt }}
        template(v-if="Object.keys(obj.tags).length > 0")
          .tags
            span.tag(v-for="tag in Object.keys(obj.tags)") {{ tag }}
      .pnl-action
        .hatebu
          .hatebu-cnt(:style="hatebuCntStyle") {{ obj.hatebuCnt }}
        .archive
          icon-button.c-archive(
            @click.native="mArchive(obj.eid)"
            icon="ion-ios-checkmark-empty"
            :loading="ingArchive"
            :disabled="obj.archived"
            icon-disabled="ion-ios-checkmark"
          )
  template(v-else)
    span.loading
      i.ion-load-d
</template>

<script>
import { mapState, mapActions } from "vuex";
import FitImage from "@/components/FitImage";
import Clickable from "@/components/Clickable";
import IconButton from "@/components/IconButton";

export default {
  props: ["obj"],
  components: {
    FitImage,
    Clickable,
    IconButton
  },
  data() {
    return {
      DEBUG: process.env.NODE_ENV === "development",
      imgSrc: this.obj.image_s3_url,
      ingArchive: false
    };
  },
  computed: {
    ...mapState(["activeEid"]),
    compoClasses() {
      return {
        archived: this.obj.archived,
        active: this.obj.eid === this.activeEid
      };
    },
    linkTitle() {
      return this.obj.title ? this.obj.title : this.obj.url;
    },
    hatebuCntStyle() {
      const cnt = this.obj.hatebuCnt;
      let style;
      switch (true) {
        case cnt >= 500:
          style = { color: "#F50057", fontWeight: 900 };
          break;
        case cnt >= 100:
          style = { color: "#FF4081", fontWeight: 600 };
          break;
        case cnt >= 10:
          style = { color: "#FF4081", fontWeight: 100 };
          break;
        default:
          style = { color: "#9E9E9E" };
      }
      return style;
    }
  },
  methods: {
    ...mapActions(["activate"]),
    async handleLoadImageError() {
      const etag = await this.$store.dispatch("fetchLibraThumb", this.obj);
      const imgUrl = this.imgSrc.replace(/\?etag=.*/, "");
      this.imgSrc = `${imgUrl}?etag=${etag}`;
    },
    async mArchive(eid) {
      this.ingArchive = true;
      await this.$store.dispatch("archive", eid);
      this.ingArchive = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.pnl
  display flex
  .pnl-thumb
    figure
      display flex
      margin 0 15px 0 0
      width 100px
      height 80px
      overflow hidden
      align-items center
      justify-content center
  .pnl-body
    flex 1
    display flex
    flex-direction column
  .pnl-action
    width 60px
    display flex
    flex-direction column
    align-items center
    justify-content space-between
    > div
      padding 3px 0

.v-entry
  min-height 111px
  padding 15px 0
  color #757575
  border-bottom 1px solid #f5f5f5
  &.active
    background-color lemonchiffon
  &.archived
    background-color #eee
  .loading
    font-size 1.5rem
  .thumb
    width 100px
    height 80px
  .link
    margin 0 0 .25em
    line-height 1.3
    word-break break-word
    a
      font-weight bold
      text-decoration none
      color #24292e
      &:hover
        text-decoration underline
  .meta
    margin 0 0 .5em
    font-size 0.67em
    span
      margin-right 1em
  .excerpt
    font-size 0.67em
    -webkit-line-clamp 2
    display -webkit-box
    -webkit-box-orient vertical
    overflow hidden
    word-break break-word
  .tags
    .tag
      display inline-flex
      margin 0 .5em 0 0
      padding 0 .5em
      font-weight bold
      font-size .67em
      border-radius 2px
      align-items center
      line-height 1.5
      border 1px solid #9ea8b3
      color #fff
      background-color #9ea8b3
  .pnl-action
    button
      color inherit
      font inherit
      margin 0
      padding 0
      text-align inherit
      line-height inherit
      display inline
      background none
      overflow visible
      border none
      cursor pointer
  .hatebu
    .hatebu-cnt
      line-height 1
      font-size 0.75rem
      letter-spacing -0.05em
  .fav
    line-height 1
    .v-clickable button
      padding 3px
      line-height 1
    span
      font-size 1.25rem
      cursor pointer
  .archive
    line-height 1
    .v-clickable button
      padding 3px
      line-height 1
    span
      font-size 1.25rem
      cursor pointer
      color #9ea8b3
</style>
